import View from '../view/view';

import { promisify } from '../utils/promisify';

export default View.extend( {
    
    open() {
        return this.render();
    },

    inject(options = {}) {
        Object.assign( this.options, options );
    },
    
    start() {
        return this;
    },
    
    attached($el) {
        $( document.body ).append( `<style>
            .loader:before { background-color: #d9edf7; }
        </style>` );

        return this;
    },
    
    detached() {
        return this;
    },
    
    stop() {
        return this;
    },

    state() {
        return this.state_;
    },

    setState(state = {}) {
        const oldState = this.state_ || {};
        this.state_ = { ...oldState, ...state };

        return this;
    },

    url() {
        return '';
    },

    navigated() {
        return this.trigger( 'url:navigate', this.url(), this.state() );
    },
    
}, {

    BACK: 'module-common--back',

} );


// WEBPACK FOOTER //
// ./src/js/core/module.js